import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionRetryToaster"] */ "/app/src/components/connection-retry-toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoBadge"] */ "/app/src/components/demo-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopBadgeSync"] */ "/app/src/components/desktop-badge-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartAppBanner"] */ "/app/src/components/smart-app-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInit"] */ "/app/src/components/theme-init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/lib/i18n/index.ts");
